import { getProfileIdModelUtil } from '../../../../models/utils/get-profile-id'
import { getCurrentOrCustomerIdProfileSelect } from '../../../profile/redux/selectors/get-current-or-customer-id'
import getByProfileIdDataPeriodDomainListPathFromDomainPathReduxUtil
  from '../get-by-profile-id-data-period-domain-list-path-from-domain-path'
import getCreatedAtReduxUtil from '../get-created-at'
import getDomainPathReduxUtil from '../get-domain-path'

export default function getByProfileIdDataPeriodDomainListPathReduxUtil ({
  instance,
  datePeriodUnit,
  date = getCreatedAtReduxUtil(instance),
  state
}) {
  const profileId = getProfileIdModelUtil(instance) || (
    state && getCurrentOrCustomerIdProfileSelect(state)
  )
  return getByProfileIdDataPeriodDomainListPathFromDomainPathReduxUtil({
    profileId,
    datePeriodUnit,
    date,
    domainPath: getDomainPathReduxUtil(instance)
  })
}
